if (!customElements.get("f-cart-goal")) {
  class FCartGoal extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        cartDrawer: ".f-cart-drawer__inner",
        leftToSpend: "[data-left-to-spend]",
        defaultMessage: ".f-cartgoal__default-message",
        successMessage: ".f-cartgoal__success-message",
        barFill: ".f-cartgoal__bar-fill",
        icon: ".f-cartgoal__icon",
      };

      this.confettiShow = false;

      // fixed_goal=true  → threshold in presentment currency (GBP/EUR/USD/CAD/NOK market). Use directly.
      // fixed_goal=false → threshold in USD (International market).
      //   JS converts: (usd / gbp_usd_rate) × window.Shopify.currency.rate (= GBP→local rate, always valid)
      //   e.g. MY=350 USD: (350 / 1.33) × 5.39 ≈ RM1418 ✓
      //   e.g. SG=300 USD: (300 / 1.33) × 1.71 ≈ SGD 386 ✓
      if (this.dataset.fixedGoal === "true") {
        this.goal = Number(this.dataset.cartGoal) || 0;
      } else {
        const usdRate    = Number(this.dataset.usdRate) || 1.33;
        const gbpToLocal = Number(window.Shopify?.currency?.rate) || 1;
        this.goal = (Number(this.dataset.cartGoal) / usdRate) * gbpToLocal || 0;
      }

      this.money_format   = window.FoxThemeSettings.money_format;
      this.enableConfetti = this.dataset.enableConfetti === "true";
    }

    connectedCallback() {
      this.updateCartGoal(Number(this.dataset.cartTotal));

      this._cartUpdateUnsub = window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, (state) => {
        if (state && state.items_subtotal_price !== undefined) {
          this.updateCartGoal(state.items_subtotal_price);
        } else {
          // Cart add response (/cart/add.js) — fetch cart to get current total
          this._refreshFromCart();
        }
      });

      // Also update when the cart drawer opens — guarantees bar shows after quick-add
      this._cartOpenUnsub = window.FoxThemeEvents.subscribe('ON_CART_DRAWER_OPEN', () => this._refreshFromCart());
    }

    disconnectedCallback() {
      if (this._cartUpdateUnsub) this._cartUpdateUnsub();
      if (this._cartOpenUnsub)   this._cartOpenUnsub();
    }

    _refreshFromCart() {
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(r => r.json())
        .then(cart => this.updateCartGoal(cart.items_subtotal_price))
        .catch(() => {});
    }

    // ─── Progress bar update ─────────────────────────────────────────────────

    updateCartGoal(state) {
      if (state > 0) {
        this.classList.remove("hidden");
      } else {
        this.classList.add("hidden");
        return;
      }

      this.cartTotal = state / 100;
      const done = this.cartTotal >= this.goal;

      const fillPct = Math.min((this.cartTotal / this.goal) * 100, 100);
      this.style.setProperty("--progress", `${fillPct}%`);
      const barFill = this.querySelector(this.selectors.barFill);
      if (barFill) barFill.style.width = `${fillPct}%`;

      const defaultMsgEl = this.querySelector(this.selectors.defaultMessage);
      const successMsgEl = this.querySelector(this.selectors.successMessage);

      if (done) {
        this.classList.add("f-cartgoal--done");
        if (defaultMsgEl) defaultMsgEl.style.display = 'none';
        if (successMsgEl) successMsgEl.style.display = '';
      } else {
        this.classList.remove("f-cartgoal--done");
        if (successMsgEl) successMsgEl.style.display = 'none';
        if (defaultMsgEl) defaultMsgEl.style.display = '';
        const leftToSpend = this.querySelector(this.selectors.leftToSpend);
        if (leftToSpend) {
          const spend = Math.max((this.goal - this.cartTotal) * 100, 0);
          leftToSpend.innerHTML = formatMoney(spend, this.money_format);
        }
      }

      this.dataset.total = this.cartTotal;

      if (done && this.enableConfetti) {
        this.showConfetti();
      } else if (!done) {
        this.confettiShow = false;
      }
    }

    // ─── Confetti ─────────────────────────────────────────────────────────

    showConfetti() {
      const cartDrawer  = this.closest(this.selectors.cartDrawer);
      const cartTemplate= this.closest(".cart-template");

      if (!this.confettiShow && (cartDrawer || cartTemplate)) {
        setTimeout(() => {
          if (cartDrawer)   new window.FoxTheme.Confetti(cartDrawer);
          if (cartTemplate) new window.FoxTheme.Confetti(document.body);
          this.confettiShow = true;
        }, 800);
      }
    }
  }

  customElements.define("f-cart-goal", FCartGoal);
}
